RivalIQ.module('postTags.collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.PostTags = RivalIQ.collections.AtomicCollection.extend({
        model: App.postTags.models.PostTag,

        url: function () {
            return `/api/landscape/${RivalIQ.state.landscape.id}/postTags`;
        },

        comparator: function (postTag) {
            return postTag.get('tag_name').toLowerCase();
        }
    });
});
